'use strict';

angular.module('atex.dam').controller('DamThumblistRowController', [ '$scope', '$window', 'configuration', '$state', '$stateParams','DamStatusService', 'DamNotificationService', '$translate', '$rootScope', '$modal', '$q', 'DamConfigurationService', 'ClipboardService',
  function($scope, $window, configuration, $state, $stateParams,DamStatusService, DamNotificationService, $translate, $rootScope, $modal, $q, DamConfigurationService, ClipboardService) {

    $scope.error = false;

    $scope.checkboxSelectionCallback = $scope.checkboxSelectionCallback();
    $scope.openEntryCallback = $scope.openEntryCallback();
    $scope.selectEntryCallback = $scope.selectEntryCallback();
    $scope.hasRead = $scope.hasRead();
    $scope.isHasReadEnabled = $scope.isHasReadEnabled();


    $scope.pGalleryFieldsEdit = configuration.getPGalleryFieldsEdit();

    $scope.attributes = [];

    DamStatusService.getAttributesList().then(function (attrs) {
      attrs.forEach(function (attribute) {
        if (attribute.views.includes("thumb_list")) {
          var attr = {
            id: attribute.attributeID,
            name: attribute.name,
            shortName: attribute.shortName,
            icon: attribute.icon
          };
          $scope.attributes.push(attr);
        }
      });
    }).then(null, function (error) {
      var message = "Error: " + error.cause;
      if ($translate.getTranslationTable() !== null) {
        message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
      }
      DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
    });

    $scope.readOnlyPreview = function (entry, $event) {
      if ($event.shiftKey === true){
        $window.open('/act/#/preview/' + entry.id, '_blank').focus();
      }
    };

    $scope.getAttributesList = function (attrs) {
      var rows = [];
      $scope.attributes.forEach(function (attribute) {
        var content;
        if (attrs && attrs.includes(attribute.id)) {
          content = attribute;
        }
        rows.push(content);
      });

      return rows;
    };

    $scope.checkLock = function (item) {
      var promise = $scope.lockIconCallback();
      if (!promise) {
        return;
      }
      $scope.checkingLock = true;
      promise.call(this, item).then(function () {
        $scope.checkingLock = false;
      });
    };

    $scope.isLocked = function () {
      return $scope.data.lockData && $scope.data.lockData.edit;
    };

    $scope.isTrashed = function () {
      if (configuration.getTrashId()) {
        return $scope.data.aspects['p.InsertionInfo'].data.securityParentId === configuration.getTrashId();
      }
    };

    $scope.show = function (obj) {
      obj.$show();
      $scope.$broadcast("dam:collection-show-description");
    };

    $scope.down = function (position) {
      var move = {};
      move.from = position;
      move.to = (move.from + 1);
      $scope.$root.$broadcast("dam:collectionEntryMove", move);
    };

    $scope.up = function (position) {
      var move = {};
      move.from = position;
      move.to = (move.from - 1);
      $scope.$root.$broadcast("dam:collectionEntryMove", move);
    };

    $scope.move = function (current, next) {
      var move = {};
      move.from = current;
      move.to = next;
      $scope.$root.$broadcast("dam:collectionEntryMove", move);
    };

    $scope.go = function (pos) {
      if (pos !== undefined) {
        if ((pos > 0) && (pos <= $scope.collectionLength)) {
          $scope.error = false;

          var move = {};
          move.to = pos;
          $scope.$root.$broadcast("dam:collectionEntryMove", move);
        } else {
          $scope.error = true;
        }
      }
    };

    $scope.copyToClipboard = function (id) {
      if (id === undefined) {
        return;
      }
      var clipboardInfo = {};
      clipboardInfo.data = [];
      var data = {
        id: 'contentid/' + id,
        type: 'atex.onecms.image'
      };
      clipboardInfo.data.push(data);
      return ClipboardService.putInClipboard(clipboardInfo).then(function (response) {
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'success',
          message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
        }), false);
      }, function (error) {
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'error',
          message: $translate.getTranslationTable().__ERROR_RETRIEVE_CLIPBOARD__
        }), true);
      });
    };

    $scope.remove = function (resourceId) {
      $scope.$root.$broadcast("dam:collectionEntryRemove", resourceId);
    };

    var _update = function(updateCrop) {

      var fields = $scope.collectionFields || [
        {
          "field": "headline",
          "initFrom": "headline"
        },
        {
          "field": "description",
          "initFrom": "description"
        }
      ];
      var contentData = atex.onecms.ObjectUtils.getByPath($scope.data, 'aspects/contentData/data') || [];

      var updateField = false;
      for (var idx = 0; idx < fields.length; idx++) {
        var f = fields[idx];
        if (!f.field || !f.initFrom) {
          console.log("MISSING fields 'field' or 'initFrom' the configuration", fields);
        } else {
          if ($scope.field[f.field] !== contentData[f.initFrom]) {
            updateField = true;
          }
        }
      }

      if ($scope.field.caption !== $scope.data.aspects.contentData.data.caption) {
        updateField = true;
      }

      if ($scope.field.organization !== $scope.data.aspects.contentData.data.organization) {
        updateField = true;
      }

      if ($scope.field.byline !== $scope.data.aspects.contentData.data.byline) {
        updateField = true;
      }

      if(updateField || updateCrop) {
        var aspect;
        if ($scope.entry.data.aspects['atex.collection']) {
          aspect = $scope.entry.data.aspects['atex.collection'].data;
          aspect._type = 'com.atex.onecms.app.dam.collection.aspect.CollectionAspect';
        } else {
          aspect = {};
          aspect._type = 'com.atex.onecms.app.dam.collection.aspect.CollectionAspect';
          $scope.entry.data.aspects['atex.collection'] = {};
          $scope.entry.data.aspects['atex.collection'].data = {};
        }
        aspect.contentId = $scope.entry.id;

        var collections = aspect.collections;
        if (!collections) {
          aspect.collections = [];
          collections = aspect.collections;
        }

        var collection;
        collections.forEach(function (tmp) {
          if (tmp.contentId === $stateParams.id) {
            collection = tmp;
          }
        });

        if (collection === undefined) {
          collection = {};
          collection.contentId = $stateParams.id;
          collection.field = {};
          collections.push(collection);
          if (aspect.collections_element_types) {
            aspect.collections_element_types.push('com.atex.onecms.app.dam.collection.aspect.Collection');
          }
        }
        collection._type = 'com.atex.onecms.app.dam.collection.aspect.Collection';
        collection.field._type = 'com.atex.onecms.app.dam.collection.aspect.Field';

        if (updateField || updateCrop) {
          collection.field.description = $scope.field.description;
          collection.field.headline = $scope.field.headline;
          collection.field.caption = $scope.field.caption;
          collection.field.organization = $scope.field.organization;
          collection.field.byline = $scope.field.byline;

        }

        if (updateCrop) {
          collection.crop = angular.copy($scope.entry.data.aspects['atex.ImageEditInfo'].data);
          delete collection.crop._type;
        }

        $scope.entry.data.aspects['atex.collection'].data = aspect;

        $scope.$root.$broadcast("dam:collectionEntryUpdate", $scope.entry);
      }
    };

    $scope.showFullParagraphStyle = function (event, direction) {
      if (direction === 'up'){
        event.currentTarget.parentElement.parentElement.classList.add("dam-thumblist-td");
      }else{
        event.currentTarget.parentElement.parentElement.classList.remove("dam-thumblist-td");
      }
      $scope.full=!$scope.full;
    };

    $scope.update = function () {
      $scope.$broadcast("dam:collection-hide-description");
      _update();
    };

    $scope.fieldChanged = function (data, fieldName) {
      if (data && fieldName) {
        $scope.field[fieldName] = data;
      }
      _update();
    };

    $scope.getNumber = function (num) {
      var values = [];
      for (var j = 0; j < num; j++) {
        values.push(j);
      }
      return values;
    };

    $scope.loadCollection = function () {
      $state.go('list.collection', {'id': $scope.data.id, preview: null});
    };


  function rewriteUrl(url, cropRect) {
    if (url) {
      var newUrl = url;
      var index = url.indexOf('?');
      if (index>0) {
        newUrl = url.substring(0, index);
      }
      newUrl += '?';
      if (cropRect) {
        newUrl += cropRect + '&';
      }
      newUrl += 'w=240';
      return newUrl;
    }
  }

  function getDefaultCrop() {
    return atex.onecms.ObjectUtils.getByPath($rootScope.currentEditingCollection, 'data/aspects/contentData/data/defaultCrop');
  }

  function calculateUrlCrop(cropName) {
    var cropRect = atex.onecms.ObjectUtils.getByPath($scope.entry.data.aspects["atex.ImageEditInfo"], ['data', 'crops', cropName, 'cropRectangle']);
    if (cropRect) {
      return $q.when('c=' + cropRect.x + ',' + cropRect.y + ',' + cropRect.width + ',' + cropRect.height);
    } else {
      // use the default aspect ratio crop
      // We cannot rely on the crop name!!!!! we need the aspect ratio
      return DamConfigurationService.getCropFormatByName(cropName).then(function(format){
        return format.aspectRatio ? 'a=' + format.aspectRatio.width + ':' + format.aspectRatio.height : undefined;
      });
    }
  }

  $scope.updateThumbCrop = function() {
    var defaultCrop = getDefaultCrop();
    var imgThumb = atex.onecms.ObjectUtils.accessor($scope.entry, 'data/aspects/contentData/data/thumbUrl').value;
    if (defaultCrop && imgThumb) {
      return calculateUrlCrop(defaultCrop).then(function(urlCrop) {
        var newThumbUrl = rewriteUrl(imgThumb, urlCrop);
        atex.onecms.ObjectUtils.accessor($scope.entry, 'data/aspects/contentData/data/thumbUrl').value = newThumbUrl;
      });
    }
  };

  if ($scope.editingCollection) {
    $scope.$on('dam:checkTumbCrop', function () {
      $scope.updateThumbCrop();
    });
  }

    $scope.crop = function(entry) {
      var templateScope = $rootScope.$new(true);
      templateScope.article = angular.copy(entry);

      var modal = $modal({
        show : true,
        scope : templateScope,
        template : 'views/dam-edit-crop-modal.html',
        modalClass : 'dam-modal-edit confirm-modal ng-cloak',
        backdrop : 'static',
        keyboard : false
      });

      templateScope.verified = (templateScope.confirm !== true);
      var deferred = $q.defer();

      var destroyModal = function() {
        modal.then(function(modalEl) {
          modalEl.on('hidden.bs.modal', function() {
            templateScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };

      templateScope.doCancel = function() {
        destroyModal();
        deferred.resolve(false);
        $rootScope.$broadcast("dam:cancelItem");
      };

      templateScope.closeModal = function(article) {
        var newImageEditInfo = atex.onecms.ObjectUtils.getByPath(article, 'data/aspects/atex.ImageEditInfo');
        if (newImageEditInfo) {
          entry.data.aspects["atex.ImageEditInfo"] = angular.copy(newImageEditInfo);
          $scope.updateThumbCrop();
        }
        _update(true);
        destroyModal();
        deferred.resolve(false);
      };

      return deferred.promise;
    };

    /**
     * Delete all the crops from the given image.
     * Broadcast dam:collectionEntryUpdate when done.
     *
     * @param entry the image content.
     */
    $scope.uncrop = function(entry) {
      var aspect = atex.onecms.ObjectUtils.getByPath(entry, "data/aspects/atex.collection/data");
      if (aspect) {
        aspect.collections.forEach(function (collection) {
          if (collection.contentId === $stateParams.id) {
            if (collection.crop && (Object.keys(collection.crop.crops || {}).length > 0)) {
              delete collection.crop;
              $scope.$root.$broadcast("dam:collectionEntryUpdate", entry);
            }
          }
        });
      }
    };

    /**
     * Detect if the given image as a specific crop for the current collection.
     *
     * @param entry the image content.
     * @return {boolean} true if we should show the remove crop button.
     */
    $scope.canShowRemoveCrop = function(entry) {
      var aspect = atex.onecms.ObjectUtils.getByPath(entry, "data/aspects/atex.collection/data");
      var canShow = false;
      if (aspect) {
        aspect.collections.forEach(function (collection) {
          if (collection.contentId === $stateParams.id) {
            if (collection.crop && (Object.keys(collection.crop.crops || {}).length > 0)) {
              canShow = true;
            }
          }
        });
      }
      return canShow;
    };
  }]);

angular.module('atex.dam').directive('damThumblistRowFields',
  ['$filter', '$sce', '$compile', '$stateParams', '$translate', '$rootScope', 'DrawerService',
  function($filter, $sce, $compile, $stateParams, $translate, $rootScope, DrawerService) {
    return {
      replace: true,
      restrict: 'E',
      template: '',
      scope : true, // so we can access outside scope
      link: function(scope, element, attrs) {
        var defHeadlineObj = {
          "type": "simple",
          "label": "_CAPTION_",
          "field": "headline",
          "initFrom": "headline"
        };
        var defDescriptionObj = {
          "type": "ckeditor",
          "label": "_DESCRIPTION_",
          "field": "description",
          "initFrom": "description"
        };
        scope.collectionFields = scope.collectionFields || [
          _.clone(defHeadlineObj),
          _.clone(defDescriptionObj)
        ];
        var html = '';
        scope.collectionFields.forEach(function(f) {
          var label = $translate.getTranslationTable()[f.label] || f.label;
          var type = '';
          var subtype = '';
          if (f.type === 'simple') {
            type = 'dam-field-editor-simple';
          } else if (f.type === 'textarea') {
            type = 'dam-field-editor-textarea';
          } else if (f.type === 'ckeditor') {
            type = 'dam-field-editor-textarea';
            subtype = ' type="ckeditor"';
          }
          html += '<' + type + ' label="' + label + '" field-name="' + f.field + '"' + subtype +'>' + '</' + type + '>\n';
        });
        var linkFn = $compile(html);
        var content = linkFn(scope);
        element.append(content);
      }
    };
  }]
);

angular.module('atex.dam').directive('damThumblistRow', [ '$filter', '$sce', '$compile', '$stateParams','$rootScope', 'DrawerService',
function($filter, $sce, $compile, $stateParams, $rootScope, DrawerService) {
  return {
    replace: true,

    restrict: 'A',

    templateUrl: 'views/dam-thumblist-row/dam-thumblist-row.html',

    scope: {
      key: '=',
      entry: '=',

      showMarkasLabel: '=',

      checkboxSelectionCallback: '&',
      selected: '=',

      selectEntryCallback: '&',
      openEntryCallback: '&',
      hasRead: '&',
      isHasReadEnabled: '&',

      editingCollection: '=',
      position: '=',
      collectionLength: '=',
      collectionFields: '=',

      lockIconCallback: '&',
      useLazySource: '@'

    },

    controller: 'DamThumblistRowController',

    compile: function (tElement, tAttrs, transclude) {
      return {
        post: function postLink(scope, iElement, iAttrs, controller) {
          scope.limitDesc = 250;

          // Check callback and in case of undefined put empty function
          if (!scope.checkboxSelectionCallback) {
            scope.checkboxSelectionCallback = function () {
            };
            scope.selCheckboxHidden = true;
          }

          if (!scope.openEntryCallback) {
            scope.openEntryCallback = function () {
            };
          }
          if (!scope.selectEntryCallback) {
            scope.selectEntryCallback = function () {
            };
          }
          if (!scope.hasRead) {
            scope.hasRead = function () {
            };
          }
          if (!scope.isHasReadEnabled) {
            scope.isHasReadEnabled = function () {
            };
          }

          scope.data = scope.entry._data ? scope.entry._data : scope.entry.data;

          if (scope.editingCollection) {
            scope.field = {};
            // Customize here the fields in the 'atex.collection' aspect that should be edited during the collection editing
            var fields = scope.collectionFields || [
              {
                "field": "headline",
                "initFrom": "headline"
              },
              {
                "field": "description",
                "initFrom": "description"
              }
            ];
            var contentData = atex.onecms.ObjectUtils.getByPath(scope.data, 'aspects/contentData/data') || [];
            for (var idx = 0; idx < fields.length; idx++) {
              var f = fields[idx];
              if (!f.field || !f.initFrom) {
                console.log("MISSING fields 'field' or 'initFrom' the configuration", fields);
              } else {
                scope.field[f.field] = contentData[f.initFrom];
              }
            }

            if (scope.entry.data !== undefined && scope.entry.data.aspects['atex.collection']) {
              var aspect = scope.entry.data.aspects['atex.collection'].data;
              aspect.collections.forEach(function (collection) {
                if (collection.contentId === $stateParams.id) {
                  scope.field.description = collection.field.description;
                  scope.field.headline = collection.field.headline;
                  scope.field.caption = collection.field.caption;
                  scope.field.organization = collection.field.organization;
                  scope.field.byline = collection.field.byline;

                }
              });
            }
          }

          scope.to_trusted = function (html_code, full) {
            if (html_code !== undefined) {
              if (typeof html_code === "object" && typeof html_code.text === 'string') {
                html_code = html_code.text;
              }
              if (!full && scope.limitDesc > 0) {
                html_code = $filter('limitHtml')(html_code, scope.limitDesc, "...");
              }
            }

            return $sce.trustAsHtml(html_code);
          };

          scope.canCollect = function () {
            if (!DrawerService.canCollectType(scope.data.aspects['contentData'].data.inputTemplate)) {
              return false;
            }
            if (DrawerService.contains(scope.data.id)) {
              return false;
            }
            return true;
          };

          scope.collect = function () {
            $rootScope.$broadcast("dam:addItemToCollector", scope.data.id);
          };

          if (scope.editingCollection) {
            scope.updateThumbCrop();
          }

        }
      };
    }
  };
}]);
